var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ui-head'),_vm._v(" "),_c('div',{ref:"container",staticClass:"container"},[_c('side-nav',{staticClass:"nav"}),_vm._v(" "),_c('router-view',{staticClass:"view"})],1),_vm._v(" "),_c('mainFooter',{attrs:{"footPosition":_vm.footPosition}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-077d8bca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/App.vue
// module id = null
// module chunks = 